<template>
  <div class="pa-0">
    <label class="darkblue--text">Upload {{ title }} Document</label>
    <vue-dropzone
      :use-font-awesome="true"
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      @vdropzone-complete="afterComplete"
      @vdropzone-reset="fileRemoved()"
    ></vue-dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    type: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        maxFilesize: 15,
        timeout: 1000000,
        acceptedFiles: '.pdf, .docx',
        maxFiles: 1,
        addRemoveLinks: true,
        dictDefaultMessage:
          '<i class="fas fa-camera"></i><span class="primary--text">Click or Drop Files Here to Upload</span>'
      }
    };
  },
  mounted() {
    console.log(this.type);
    this.dropzoneOptions.acceptedFiles = this.type;
  },
  methods: {
    afterComplete(file) {
      console.log(file.file);
      this.$emit('afterComplete', { file });
    },
    fileRemoved() {
      this.$emit('fileRemoved');
      this.$refs.myVueDropzone.removeAllFiles();
    }
  }
};
</script>
